;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import type { AdminNavKey } from "../../../../../lib/admin/adminNav"

export const TOP_NAV_MENU_TYPE_ACCOUNT = "ACCOUNT"
export const TOP_NAV_MENU_TYPE_BECOME_GROUP_LEADER = "BECOME_GROUP_LEADER"
export const TOP_NAV_MENU_TYPE_FIND_A_GROUP = "FIND_A_GROUP"
export const TOP_NAV_MENU_TYPE_GROUPS_I_ATTEND = "GROUPS_I_ATTEND"
export const TOP_NAV_MENU_TYPE_GROUPS_I_LEAD = "GROUPS_I_LEAD"
export const TOP_NAV_MENU_TYPE_LOGOUT = "LOGOUT"
export const TOP_NAV_MENU_TYPE_NEWSLETTER_SIGN_UP = "NEWSLETTER_SIGN_UP"
export const TOP_NAV_MENU_TYPE_NEWSLETTER_ACCOUNT_SETTING = "NEWSLETTER_ACCOUNT"
export const TOP_NAV_MENU_TYPE_PROFILE = "PROFILE"
export const TOP_NAV_MENU_TYPE_ORGANIZATION_PAGE = "ORGANIZATION_PAGE"
export const TOP_NAV_MENU_TYPE_SIGN_UP_LOGIN = "SIGN_UP_LOGIN"
export const TOP_NAV_MENU_TYPE_POST_A_NEW_GROUP = "POST_A_NEW_GROUP"
export const TOP_NAV_MENU_TYPE_ALL_GROUPS_ADMIN = "ALL_GROUPS"
export const TOP_NAV_MENU_TYPE_ALL_USERS_ADMIN = "ALL_USERS"
export const TOP_NAV_MENU_TYPE_ADMIN_NEWSLETTER = "ADMIN_NEWSLETTER"
export const TOP_NAV_MENU_TYPE_ADMIN_AI_USAGE = "ADMIN_AI_USAGE"
export const TOP_NAV_MENU_TYPE_ADMIN_DASHBOARD = "ADMIN_DASHBOARD"
export const TOP_NAV_MENU_TYPE_ADMIN_EMAIL = "ADMIN_EMAIL"
export const TOP_NAV_MENU_TYPE_ADMIN_HOME_PAGE = "ADMIN_HOME_PAGE"
export const TOP_NAV_MENU_TYPE_ALL_ORGANIZATIONS_ADMIN = "ALL_ORGANIZATIONS"
export const TOP_NAV_MENU_TYPE_ARTICLE_STUDIO = "ARTICLE_STUDIO"
export const TOP_NAV_MENU_TYPE_ADMIN_ARTICLES = "ADMIN_ARTICLES"
export const TOP_NAV_MENU_TYPE_MESSAGES = "MESSAGES"
export const TOP_NAV_MENU_TYPE_NOTIFICATIONS = "NOTIFICATIONS"

/** Menu row type for each admin nav item; labels/hrefs/icons come from adminNav. */
export const TOP_NAV_MENU_TYPE_BY_ADMIN_NAV_KEY: Record<AdminNavKey, string> = {
  dashboard: TOP_NAV_MENU_TYPE_ADMIN_DASHBOARD,
  users: TOP_NAV_MENU_TYPE_ALL_USERS_ADMIN,
  groups: TOP_NAV_MENU_TYPE_ALL_GROUPS_ADMIN,
  orgs: TOP_NAV_MENU_TYPE_ALL_ORGANIZATIONS_ADMIN,
  articles: TOP_NAV_MENU_TYPE_ADMIN_ARTICLES,
  newsletter: TOP_NAV_MENU_TYPE_ADMIN_NEWSLETTER,
  email: TOP_NAV_MENU_TYPE_ADMIN_EMAIL,
  home: TOP_NAV_MENU_TYPE_ADMIN_HOME_PAGE,
  aiUsage: TOP_NAV_MENU_TYPE_ADMIN_AI_USAGE,
}
